/** One stale-200 retry. A zero delay would tight-loop the probe. */
export const LINK_EXPIRY_REARM_MS = 30_000;

export type ExpiryRearm =
  | { kind: "future"; delayMs: number }
  | { kind: "once"; delayMs: number }
  | { kind: "stop" };

/**
 * Milliseconds until `expiresAt`. `0` means the local clock already says due.
 * `null` means the timestamp does not parse.
 */
export const linkExpiryDelayMs = (
  expiresAt: string,
  now: number,
): number | null => {
  const deadline = Date.parse(expiresAt);
  if (Number.isNaN(deadline)) return null;
  return Math.max(0, deadline - now);
};

/**
 * After a live GET session. A future `expiresAt` rearms to that instant.
 * Missing or already-due rearms once at {@link LINK_EXPIRY_REARM_MS}, then stops.
 */
export const expiryRearmAfterProbe = (
  expiresAt: string | null,
  now: number,
  alreadyRetriedStale: boolean,
): ExpiryRearm => {
  if (expiresAt) {
    const delay = linkExpiryDelayMs(expiresAt, now);
    if (delay != null && delay > 0) {
      return { kind: "future", delayMs: delay };
    }
  }
  if (!alreadyRetriedStale) {
    return { kind: "once", delayMs: LINK_EXPIRY_REARM_MS };
  }
  return { kind: "stop" };
};
